import { render, staticRenderFns } from "./PostPage.vue?vue&type=template&id=181af504&scoped=true&"
import script from "./PostPage.vue?vue&type=script&lang=js&"
export * from "./PostPage.vue?vue&type=script&lang=js&"
import style0 from "./PostPage.vue?vue&type=style&index=0&id=181af504&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181af504",
  null
  
)

export default component.exports